import { render, staticRenderFns } from "./CategoryPie.vue?vue&type=template&id=15f40aee&scoped=true"
import script from "./CategoryPie.vue?vue&type=script&lang=js"
export * from "./CategoryPie.vue?vue&type=script&lang=js"
import style0 from "./CategoryPie.vue?vue&type=style&index=0&id=15f40aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f40aee",
  null
  
)

export default component.exports